module.exports = __webpack_public_path__ + "img/tribe-epic.46e6fdf2.svg";